<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-p">
			<item-pre-visit-ticket-info [(ticket)]="vm.ticket" [(original)]="vm.original" [(onSave)]="vm.close"></item-pre-visit-ticket-info>
		</div>
	</div>
</div>
